export default __webpack_public_path__ + "static/media/Avatar.b98c01e1.svg";